    //
    var fn_masthead_scroll = function () {
        var mybutton = $('.masthead__arrow');
        var vheight = $(window).height();

        mybutton.on('click', function (e) {
            $('html, body').animate({
                scrollTop: (Math.floor($(window).scrollTop() / vheight)+1) * vheight
              }, 860);
        });
    };
    //
